import {observable, decorate } from 'mobx';

class InputsBlockStore {
  inputsNames = []
  store = null;
  id = null;
  isFold = false;
  title = '';

  constructor(store, obj) {
    this.store = store;
    this.id = Math.random(); //uuid.v4()
    if(obj) {
      this.inputsNames = obj.inputsName;
      this.isFold = obj.isFold;
      this.title = obj.title;
    }
  }


};

decorate(InputsBlockStore, {
  inputsNames: observable,
});

export default InputsBlockStore;
